import { useMemo } from 'react';
import { SuggestedSettingsType } from '@lp/features/RoutePlanner/types';
import { useCountriesData } from '@/contexts/CountriesDataProvider';
import { SettingsChipLabel } from './SettingsChipLabel';

type SuggestedChipsProps = {
  settings: SuggestedSettingsType[];
};

export const SuggestedChips = ({ settings }: SuggestedChipsProps) => {
  const { resolveSubdivisionName } = useCountriesData();

  const filteredSettings = useMemo(() => {
    return settings.filter((s) => s.value);
  }, [settings]);

  return (
    <div className="flex flex-wrap gap-2">
      {filteredSettings.map((item) => (
        <div key={item.type} className="flex gap-1 p-2 bg-base-60 rounded-lg">
          <SettingsChipLabel resolveSubdivisionName={resolveSubdivisionName} item={item} />
        </div>
      ))}
    </div>
  );
};
